import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const reports = {
  0: { title: "2018 Report", link: "https://drive.google.com/uc?export=download&id=1nGkjZhkBqiHAQjj-9MqiKqJtQnzc0fjG" },
  1: { title: "2020 Report", link: "https://drive.google.com/uc?export=download&id=1cwL63yE2OI2Cw62nHCuMacnkIGnG5phQ" },
  2: { title: "MCRD 2021年 年中事工", link: "https://drive.google.com/uc?export=download&id=1d7u1fpFINpfugMb7klzLUgsjA2nYfJY1" },
  3: { title: "MCRD 2021年 下半年事工", link: "https://drive.google.com/uc?export=download&id=1d_q7cRX7J4Q9T2ATmWgl1vp6l_omWtuw" },
};
class ReportLayout extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <div className="report-layout">{this.fetchReports()}</div>;
  }
  fetchReports = () => {
      var layout = []
    for (var i = 0; i < Object.keys(reports).length; i++) {
      layout.push (
        <div className="report-row">
          <label>{reports[i].title}</label>
          <Link to={"/Ministries/Reports/" + i}><Button onClick={() => this.props.updateScrollPos(0)}>View Report</Button></Link>
          <a href={reports[i].link}><Button>Download Report</Button></a>
        </div>
      );
    }
    return layout;
  };
}
export default ReportLayout;
